import { Platform } from 'react-native';
import { app_name } from "../../app.json";

export const IS_DEBUG = false;    // true - App is debuge mode, false - App is live
export const AppVersion = "2.0";
export const isNative = (Platform.OS !== 'web');
export const database = 'wc_v' + AppVersion
export const APP_KEY = 'stable';
export const APP_NAME = app_name;

export const supportUrl = "https://wc3.woogiu.com/page/support.html";
export const privacyUrl = "https://wc3.woogiu.com/page/privacypolicy.html";
export const termUrl = "https://wc3.woogiu.com/page/termsofuse.html";

export const FONT_REGULAR = Platform.OS === "ios" ? "NotoSans" : 'NotoSans-Regular';
export const FONT_BOLD = Platform.OS === "ios" ? "NotoSans" : 'NotoSans-Bold';

export const main_server = "mainbackend.woogiu.com";
export const chine_server = "shenzhenvps1.woogiworld.cn";
export const chine_image_server = "aliyun.cdn.woogiworld.cn";

export const USER_LOCATION_API_URL = "https://extreme-ip-lookup.com/json";
export const SPREAD_WORD_URL = 'https://mainbackend.woogiu.com/woogi/0.1/static/qrcode.php?size=9&margin=7&url=https://m4.io/a/' + APP_NAME;    //Invite spread the word button link
export const FORGOTPASSWORD_URL = 'http://go.woogiu.com/269';

// export const HTTP_CHINESE_SERVER = "https://shenzhenvps1.woogiworld.cn/woogi/0.1/actor/cgi.php"
// export const HTTP_MAINBACKEND_SERVER = "https://mainbackend.woogiu.com/woogi/0.1/actor/cgi.php"

// export const WEBSOCKET_CHINESE_SERVER = "wss://shenzhenvps1.woogiworld.cn/wsg"
// export const WEBSOCKET_SERVER = "wss://mainbackend.woogiu.com/wsg"

export const AUDIOFORMAT = "mp3";     // recorded audio format use to uploading audio file (webm)



// LOCAL STORAGE
export const registerInfo = "register_user_information";
export const USERINFO = "login_user_information";
export const IS_BOOKMARK_ADDED = "BrowserBookmarkStatus";
export const IS_REMEMBER = "AUTO LOGIN";

// Others
export const EMAIL_VALIDATION = /^\w+([\./-/+]?\w+)*@\w+([\./-/+]?\w+)*(\.\w{2,3})+$/;
export const CHAT_MESSAGE_LOAD_LENGTH = 30;
export const LIST_AMOUNT = 25;

// since we have different version control on different playforms,
// we have to distinguish stand-alone version and goolg-play version.
// so we need to change "and" to "and_gl" to indicate this is a google play version,
// and if this is stand-alone version we need to change platform = "and".
export const IsAndroidStandAlone = false;
// google play version by default
// platform = "and"; // for stand-along version, everytime when we release a new stand-alone version we have to manually true is flag.

/**
* So the possible reutrn values are :
* and <= android
* web <= web browser
* ios <= ios
* mac <= mac
* win <= windows
*/
export const APP_PLATFORM = () => {
    if (Platform.OS == "android")
        return "and";
    return Platform.OS;

    /*let platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        userAgent = window.navigator.userAgent,
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'mac';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'ios';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'win';
    } else if (/Android/.test(userAgent)) {
        os = 'and';
    } else if (!os && /Linux/.test(platform)) {
        os = 'linux';
    }
    return os;*/
};


export const MAKEURL = (uri) => {
    try {
        let regex = /^(?:[data]{4}:(text|image|application)\/[a-z]*)/;
        let pattern = new RegExp(regex);
        if (!pattern.test(uri)) {
            // return "https://"+ window.baseURL + "/" + uri;
            return `${Platform.OS === "android" ? "http" : "https"}://${window.baseURL}/${uri}`
        }
        return uri;
    } catch (error) {
        return uri
    }
};
